import type { ExtensionProps, NodeConfig, RicosExtension, RicosServices } from 'ricos-types';

import { createRicosNodeExtension } from './create-ricos-extension';

export const keymapOverride = createRicosNodeExtension<{
  services: RicosServices;
}>({
  name: 'keymap-override',
  groups: ['shortcuts-enabled'],
  type: 'html-node',
  reconfigure: (
    config: NodeConfig,
    _extensions: RicosExtension[],
    _props: ExtensionProps,
    settings: Record<string, unknown>,
    services: RicosServices
  ) => {
    return {
      ...config,
      addOptions() {
        return {
          services,
          HTMLAttributes: {},
          ...settings,
        };
      },
    };
  },

  createExtensionConfig() {
    return {
      name: this.name,
      inline: true,
      group: 'inline',
      priority: Infinity,

      selectable: false,

      addKeyboardShortcuts() {
        const tiptapKeyboardShortcuts: any = {};

        //TODO: move to shortcut agregate
        const needToCancelEnter = this.options.services.shortcuts
          .asArray()
          .some(s => s.getName() === 'Enter');

        if (needToCancelEnter) {
          tiptapKeyboardShortcuts.Enter = () => true;
        }

        return {
          ...tiptapKeyboardShortcuts,
        };
      },
    };
  },
});
